import { BaseService } from "./BaseService";

export class AttributeConfigService extends BaseService {
  getAttributes(profileId) {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETATTRIBUTECONFIG + "?profileID=" + profileId);
  }
}
